import React from 'react';
import PropTypes from 'prop-types';
import RenderComponents from "../JsonScreen/Screen/ScreenComponents/RenderComponents";
import {uid} from "react-uid";

const Footer = (props) => {
    const {
        component: {
            children = [],
            styles: sourceStyles
        }
    } = props;
    const styles = sourceStyles ? sourceStyles[0] : {};
    return (
        <div
            style={styles}
        >
            {children.map(component => {
                return <RenderComponents
                            key={uid(component)}
                            element={component}
                            isTableCell={false}
                            actionsContext={{}}
                        />
            })}
        </div>
    );
};

Footer.propTypes = {
    component: PropTypes.object
};

export default Footer;